import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createSchoolEntry = createAsyncThunk('createSchoolEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSchool`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateSchoolEntry = createAsyncThunk('updateSchoolEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateSchool`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSchoolData = createAsyncThunk('fetchSchoolData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSchoollist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleSchool = createAsyncThunk('fetchSingleSchool', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSchoollist&schoolId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleSchool = createAsyncThunk('deleteSingleSchool', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteSchool&schoolId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const schoolSlice = createSlice({
    name: 'SchoolData',
    initialState: {
        isLoading: false,
        school: null,
        deleteSchool: null,
        singleSchool: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSchoolData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSchoolData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.school = action.payload;
        });
        builder.addCase(fetchSchoolData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleSchool.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleSchool.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteSchool = action.payload;
        });
        builder.addCase(deleteSingleSchool.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleSchool.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleSchool.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleSchool = action.payload;
        });
        builder.addCase(fetchSingleSchool.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default schoolSlice.reducer;
